import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import "react-image-crop/dist/ReactCrop.css";
import { secretaryAllAppointment } from "../../config/service";
import "../Dashborad/dashboard.css";
import SecretaryMeeting from "./SecretaryMeeting";

const SecretaryDashboard = () => {
  const status = localStorage.getItem("status");
  console.log("status", status);
  const [allAppointment, setAllAppointment] = useState([]);
  const [meetingValue, setMeetingValue] = useState("past");
  const [medicalq, setMedicalQ] = useState(false);
  const [qData, setQData] = useState();
  const [comentModal, setCommentModal] = useState(false);
  const [loader, setLoader] = useState(true);
  const [note, setNote] = useState("");
  const [open, setOpen] = useState(false);

  const handleClose6 = () => (
    setMedicalQ(false),
    AllApoinmentSecretary({ val: "past" }),
    setQData({}),
    setMeetingValue("past")
  );
  const handleClose2 = () => (
    setCommentModal(false),
    AllApoinmentSecretary({ val: "past" }),
    setMeetingValue("past")
  );

  const handleCloseSummary = () => (
    setOpen(false),
    AllApoinmentSecretary({ val: meetingValue }),
    setMeetingValue(meetingValue)
  );

  useEffect(() => {
    AllApoinmentSecretary({ val: "past" });
  }, []);

  const AllApoinmentSecretary = async ({ val }) => {
    setLoader(true);
    const data = {
      meeting_status: val,
    };
    const response = await secretaryAllAppointment(data);
    setAllAppointment(response.data.result);
    setLoader(false);
  };

  return (
    <div className="secretary-dashboard-container">
      <section className="statusWrapper doctor-dashboard">
        <div className="container">
          <div className="row">
            <div className="col-lg-12"></div>
          </div>
        </div>
      </section>
      <SecretaryMeeting
        allAppointment={allAppointment}
        handleClose5={handleClose6}
        medicalq={medicalq}
        setMedicalQ={setMedicalQ}
        qData={qData}
        setQData={setQData}
        handleClose2={handleClose2}
        comentModal={comentModal}
        setCommentModal={setCommentModal}
        loader={loader}
        handleCloseSummary={handleCloseSummary}
        open={open}
        setOpen={setOpen}
        AllApoinmentSecretary={AllApoinmentSecretary}
        setMeetingValue={setMeetingValue}
        meetingValue={meetingValue}
        setNote={setNote}
        note={note}
      />
    </div>
  );
};
export default SecretaryDashboard;
